
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 13h2.059A9.012 9.012 0 0011 20.941V23a1 1 0 102 0v-2.059A9.012 9.012 0 0020.941 13H23a1 1 0 100-2h-2.059A9.012 9.012 0 0013 3.059V1a1 1 0 10-2 0v2.059A9.012 9.012 0 003.059 11H1a1 1 0 100 2zm10-7.92V7a1 1 0 102 0V5.08A7.004 7.004 0 0118.92 11H17a1 1 0 100 2h1.92A7.005 7.005 0 0113 18.92V17a1 1 0 10-2 0v1.92A7.004 7.004 0 015.08 13H7a1 1 0 100-2H5.08A7.005 7.005 0 0111 5.08z","fill":"#fff"}})])
          )
        }
      }
    